import { render, staticRenderFns } from "./ClienteXUnidadeFilterBar.vue?vue&type=template&id=112648e6"
import script from "./ClienteXUnidadeFilterBar.vue?vue&type=script&lang=js"
export * from "./ClienteXUnidadeFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports